import { TableSchema } from '../metadata-schema';

export const dim_clc_cijfer_label_conversie: TableSchema = {
	"$schema": "https://json-schema.org/draft/2020-12/schema",
	"title": "dim_clc_cijfer_label_conversie",
	"description": "Definitie voor dimension tabel dim_clc_cijfer_label_conversie uit de CumLaude DWH",
	"type": "object",
	"implements": [
		"nl.topicus.cumlaude.metadata.table.DimTable",
		"nl.topicus.cumlaude.metadata.table.Instellingspecifiek"
	],
	"properties": {
		"clc_abb_label": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false
		}
	}
};
